<template>
  <div id="app">
    <router-view />
    <loader v-if="this.$store.state.isLoading"></loader>
    <portal-target name="modal"></portal-target>
    <span v-if="version" class="version" @click.prevent="copyVersion">
      Version: {{ version }}
    </span>
    <div v-if="gamepadEnabled" class="pad-test" id="pad-test">
      <div class="pad-test__webview">
        <div id="webview"></div>
        Webview
      </div>
      <div class="pad-test__focus">
        <div id="focus"></div>
        Focus
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import { mapState } from "vuex";
const userSessionPollingInterval = 500;

export default {
  data() {
    return {
      gamepadEnabled: process.env.VUE_APP_GAMEPAD_ENABLED === "true",
    };
  },
  computed: {
    ...mapState({
      version: (state) => state.launcherVersion,
      system: (state) => state.system,
      platformSession: (state) => state.platformSession,
    }),
  },
  // mounted() {
  //   console.log("mounted", this.gamepadEnabled);
  //   //   if (this.system === 'windows') {
  //   //   }
  // },
  created() {
    this.$store.dispatch("getLaunchableGame");
    this.$store.dispatch("getSystem");
    this.$store.dispatch("getArchitecture");
    this.$store.dispatch("getVersion");
    this.$store.dispatch("getLanguage");
    this.$store.dispatch("getCacheVersion");
    this.$store.dispatch("displayContinue");
    // this.$store.dispatch("getMerchProducts");

    this.userSessionPolling(20);
    this.$store.dispatch("getGraphicsBackend");

    this.getGame();
  },

  methods: {
    async copyVersion() {
      try {
        await navigator.clipboard.writeText(this.version);
      } catch (err) {
        console.log("error while copying version number:", err);
      }
    },
    getGame() {
      if (this.$route.name === "bg3" || this.$route.query.game === "bg3") {
        this.$store.dispatch("setGame", "bg3");
      }
      if (this.$route.name === "dos2" || this.$route.query.game === "dos2") {
        this.$store.dispatch("setGame", "dos2");
      }
      if (this.$route.name === "dos" || this.$route.query.game === "dos") {
        this.$store.dispatch("setGame", "dos");
      }
    },
    async userSessionPolling(countdown) {
      if (countdown > 0) {
        // console.log("Trying to load user session: ", countdown);

        await this.$store.dispatch("getPlatformSession");
        if (
          typeof CefSharp !== "undefined" &&
          (!this.platformSession ||
            !this.platformSession.platform ||
            !this.platformSession.token)
        ) {
          setTimeout(
            this.userSessionPolling,
            userSessionPollingInterval,
            countdown - 1
          );
        }
      }
    },
  },
};
</script>

<style lang="scss">
.pad-test {
  display: flex;
  position: absolute;
  bottom: 4vh;
  left: 11vw;
  opacity: 0;

  &__webview,
  &__focus {
    color: $white;
    font-size: 10px;
    text-align: center;
    margin-right: 20px;
  }
}
#webview,
#focus {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #fff;
  margin: 0 auto;
}
.version {
  position: absolute;
  left: 5vw;
  bottom: 4vh;
  color: $white-30;
  font-size: 11px;
  cursor: pointer;

  &::selection {
    background-color: #ffe176;
    color: black;
  }
}

.lang {
  position: absolute;
  bottom: 0;
  right: 0;
  color: $yellow;
}
</style>
